import { render, staticRenderFns } from "./Formulario3.vue?vue&type=template&id=1fa3ee4e&scoped=true"
import script from "./Formulario3.vue?vue&type=script&lang=js"
export * from "./Formulario3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa3ee4e",
  null
  
)

export default component.exports